module.exports = __webpack_public_path__ + "static/banner-mobile-18a59d448a883e2b70a73de4b69420c6.png";